export default {
  presenter: 'puzman',
  title: 'Instalujeme Arch Linux',
  subtitle: 'mírně pokročilí',
  text: `
Nebaví vás vaše distribuce, hledáte alternativu a Gentoo je pro vás příliš hardcore? Pak je
tento workshop práve pro vás! Ve virtuálním prostředí projdeme kroky instalace základního systému,
naučíme se ovládat nástroj pacman. Přidáme grafické rozhraní a zakončíme sestavením a instalací
balíčku z AUR - Arch User Repository. Ukážeme si, jak si zásadně usnadnit práci s AUR pomocí yaourt.
  `,
}



// WEBPACK FOOTER //
// ./src/content/installfest/data/presentations/puzman-archlinux.js